import { ChevronDown } from 'lucide-react';
import type { MembershipTypeRow } from '../../api/membership.api';

type Props = {
  value: string;
  onChange: (typeUuid: string) => void;
  tiers: MembershipTypeRow[];
};

const MembersTierFilter = ({ value, onChange, tiers }: Props) => (
  <label className="members-tier-filter">
    <select
      className="members-tier-filter__select"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      data-testid="members-tier-filter"
      aria-label="Filter by tier"
    >
      <option value="">All tiers</option>
      {tiers.map((tier) => (
        <option key={tier.membershipTypeUuid} value={tier.membershipTypeUuid}>
          {tier.name}
        </option>
      ))}
    </select>
    <span className="members-tier-filter__chevron" aria-hidden="true">
      <ChevronDown size={14} />
    </span>
  </label>
);

export default MembersTierFilter;
